"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportScm = exports.reportBundle = void 0;
const uuid = __importStar(require("uuid"));
const lodash_pick_1 = __importDefault(require("lodash.pick"));
const constants_1 = require("./constants");
const emitter_1 = require("./emitter");
const http_1 = require("./http");
const sleep = (duration) => new Promise(resolve => setTimeout(resolve, duration));
async function initAndPollReportGeneric(initReportFunc, getReportFunc, options) {
    emitter_1.emitter.analyseProgress({
        status: http_1.AnalysisStatus.waiting,
        progress: 0,
    });
    // First init the report
    const initResponse = await initReportFunc(options);
    if (initResponse.type === 'error') {
        return initResponse;
    }
    const pollId = initResponse.value;
    let apiResponse;
    let response;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        // eslint-disable-next-line no-await-in-loop
        apiResponse = await getReportFunc({
            ...lodash_pick_1.default(options, ['baseURL', 'sessionToken', 'source', 'requestId', 'org']),
            pollId,
        });
        if (apiResponse.type === 'error') {
            return apiResponse;
        }
        response = apiResponse.value;
        if (response.status === http_1.AnalysisStatus.waiting ||
            response.status === http_1.AnalysisStatus.fetching ||
            response.status === http_1.AnalysisStatus.analyzing ||
            response.status === http_1.AnalysisStatus.done) {
            // Report progress of fetching
            emitter_1.emitter.analyseProgress(response);
        }
        else if (response.status === http_1.AnalysisStatus.complete) {
            // Return data of analysis
            return apiResponse;
            // deepcode ignore DuplicateIfBody: false positive it seems that interface is not taken into account
        }
        else if (response.status === http_1.AnalysisStatus.failed) {
            // Report failure of analysing
            return apiResponse;
        }
        // eslint-disable-next-line no-await-in-loop
        await sleep(constants_1.POLLING_INTERVAL);
    }
}
async function reportBundle(options) {
    var _a, _b;
    const projectName = (_b = (_a = options.report) === null || _a === void 0 ? void 0 : _a.projectName) === null || _b === void 0 ? void 0 : _b.trim();
    if (!projectName || projectName.length === 0) {
        throw new Error('"project-name" must be provided for "report"');
    }
    if (/[^A-Za-z0-9-_/]/g.test(projectName)) {
        throw new Error(`"project-name" must not contain spaces or special characters except [/-_]`);
    }
    // Trigger bundle analysis and emit intermediate progress.
    const response = await initAndPollReportGeneric(http_1.initReport, http_1.getReport, options);
    if (response.type === 'error') {
        throw response.error;
    }
    else if (response.value.status === http_1.AnalysisStatus.failed) {
        throw new Error('Analysis has failed');
    }
    return response.value;
}
exports.reportBundle = reportBundle;
async function reportScm(options) {
    var _a, _b;
    const projectId = (_a = options.projectId) === null || _a === void 0 ? void 0 : _a.trim();
    if (!projectId || projectId.length === 0) {
        throw new Error('"project-id" must be provided for "report"');
    }
    if (!uuid.validate(projectId)) {
        throw new Error('"project-id" must be a valid UUID');
    }
    const commitId = (_b = options.commitId) === null || _b === void 0 ? void 0 : _b.trim();
    if (!commitId || commitId.length === 0) {
        throw new Error('"commit-id" must be provided for "report"');
    }
    // Trigger SCM project analysis and emit intermediate progress.
    const response = await initAndPollReportGeneric(http_1.initScmReport, http_1.getScmReport, options);
    if (response.type === 'error') {
        throw response.error;
    }
    else if (response.value.status === http_1.AnalysisStatus.failed) {
        throw new Error('Analysis has failed');
    }
    return response.value;
}
exports.reportScm = reportScm;
//# sourceMappingURL=report.js.map